import React from 'react';

const FadeLeft = ({ children, className, duration, easing, mirror, once, offset, anchorPlacement }) => {
    return (
        <div
            className={className}
            data-aos="fade-left"
            data-aos-duration={duration}
            data-aos-easing={easing}
            data-aos-mirror={mirror}
            data-aos-once={once}
            data-aos-offset={offset}
            data-aos-anchor-placement={anchorPlacement}
        >
            {children}
        </div>
    );
};

FadeLeft.defaultProps = {
    duration: '1500',
    easing: 'ease-in-out',
    mirror: false,
    once: false,
    offset: '0',
    anchorPlacement: 'top-bottom',
};

export default FadeLeft;
